// extracted by mini-css-extract-plugin
export var textInput = "_ge-0";